
import { getSVGIcon } from "~/functions"
import { Operator } from "~/types/operator"

export const kali: Operator = {
	id: 'kali',
	name: 'Kali',
	role: 'Attacker',
	org: 'NIGHTHAVEN',
	squad: 'NIGHTHAVEN',
	ratings: {
		health: 2,
		speed: 2,
		difficulty: 2
	},
	meta: {
		gender: 'f',
		country: 'in',
		season: 'Y4S4',
		height: 170,
		weight: 67,
		price: {
			renown: 10000,
			r6credits: 240
		}
	},
	bio: {
		real_name: 'Jaimini Kalimohan Shah',
		birthplace: 'Amreli, India'
	},
	svg: {
		contents: '<switch><foreignObject width="1" height="1" x="0" y="0" requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/"></foreignObject><g><path d="M45 45h260v260H45z" style="opacity:.4"></path><path d="M277 277H73V90.389l33.229-33.868L122.5 73h104.778l16.154-16.447L277 90.389z" style="fill:#00bfca"></path><path d="m261.77 75.036-30.568 30.636c-9.449-2.098-16.474-5.134-21.258-7.617-6.822-3.541-8.826-5.809-16.111-8.5-3.831-1.415-10.442-3.789-19.278-3.722-8.36.063-14.613 2.281-18.111 3.556-5.467 1.992-3.632 2.207-17.479 9.04-5.784 2.854-11.136 5.299-18.354 7.016-.616.146-1.179.27-1.712.383l-30.94-30.685L73 90.389V215.25l73.083 60.611 28.819 28.694 29.014-29 73.083-60.514V90.388zM175 91.208c9.665 0 17.5 7.835 17.5 17.5s-7.835 17.5-17.5 17.5-17.5-7.835-17.5-17.5 7.835-17.5 17.5-17.5m0 70.667-47.359-47.313a53.5 53.5 0 0 1 8.942 3.063c3.287 1.463 5.029 2.639 7.5 4.083 3.801 2.222 10.941 6.396 19.816 8.532 2.178.524 5.804 1.361 10.656 1.426 2.581.034 8.632-.109 17.593-3.22 10.062-3.493 11.452-6.469 21.268-10.697a79 79 0 0 1 8.92-3.212z"></path><path d="M175 126.208c9.665 0 17.5-7.835 17.5-17.5s-7.835-17.5-17.5-17.5-17.5 7.835-17.5 17.5 7.835 17.5 17.5 17.5m0-26a8.5 8.5 0 1 1-.001 17.001 8.5 8.5 0 0 1 .001-17.001" style="fill:#fff"></path><path d="M73 90.389v98.861l101.556 101.472L277 189.111V90.389l-102 84.976z" style="fill:#fff"></path><path d="m161.889 216.5 12.528 64.542 12.375-64.584-12.459-24.736zM56.625 124.292 73 133.735V157a138 138 0 0 0 11.801 13.954c2.194 2.266 4.001 3.942 7.616 7.296 4.515 4.188 5.787 5.13 7.083 5.944 3.578 2.247 6.768 3.158 8.5 3.639 7.541 2.094 13.935 1.161 17.928.537 3.652-.571 4.882-1.137 13.322-3.62a585 585 0 0 1 15.194-4.25l-97.819-66.062zm40.125 25.375 38.333 24.688c-1.693 1.774-5.828 5.609-12.272 6.969-7.529 1.589-16.802-.497-22.783-7.74-5.504-6.665-6.771-15.94-3.278-23.917m98.333 30.805a211 211 0 0 1 10.64 2.633c8.839 2.43 11.341 3.731 17.902 4.811 5.681.935 9.234.854 11.375.708 1.834-.125 4.761-.34 8.056-1.347 1.642-.502 5.241-1.771 11.944-7.111 1.298-1.034 6.995-5.632 14.833-14.792 3.158-3.69 5.584-6.86 7.167-9v-21.958l16.271-10.562v-9.542zm48.703-1.843c-9.294 5.531-21.505 3.688-28.939-4.532l38.215-24.451c4.559 10.718.477 23.179-9.276 28.983"></path></g></switch>',
		attributes: {
			xmlns: 'http://www.w3.org/2000/svg',
			space: 'preserve',
			viewBox: '0 0 350 350',
			class: 'r6operators r6operators-kali'
		}
	},
	toSVG: function(userAttr){return getSVGIcon(this, userAttr)}
}
